<template>
    <table
        class="mds-data-table"
        role="grid"
    >
        <caption
            v-if="caption"
            class="mds-data-table__caption"
        >
            {{ caption }}
        </caption>
        <Header :columns-config="compColumnsConfig">
            <template v-slot:header-cell="cellData">
                <slot
                    name="header-cell"
                    v-bind="cellData"
                />
            </template>
        </Header>
        <Body
            :columns-config="compColumnsConfig"
            :data="data"
        >
            <template v-slot:cell="cellData">
                <slot
                    name="cell"
                    v-bind="cellData"
                />
            </template>
        </Body>
    </table>
</template>

<script>
import { nullableTableValue, getDefaultColumnsConfiguration } from '@/utils/data-table';
import Header from '@/components/molecules/data-table/header';
import Body from '@/components/molecules/data-table/body';

export default {
  components: { Header, Body },

  props: {
    data: { type: Array, default: () => [] },
    columnsConfig: { type: Array, default: () => null },
    caption: { type: String, default: '' },
  },

  computed: {
    compColumnsConfig() {
      const { columnsConfig, data } = this;
      return getDefaultColumnsConfiguration({ columnsConfig, data });
    },
  },

  methods: { nullableTableValue },
};
</script>
